import { QueryFunctionContext } from '@tanstack/react-query';
import { UseTournamentsBySlugQueryKeyProps } from './props';
import baseAPI from '@/api';
import { TournamentWithStats } from '@/models/tournament/with-stats';

export async function fetchTournamentsWithStatsBySlug({
  queryKey,
}: QueryFunctionContext<UseTournamentsBySlugQueryKeyProps>) {
  const { slug } = queryKey[1];

  const response = await baseAPI.get<TournamentWithStats>(
    '/tournaments/by-slug',
    {
      params: {
        slug,
      },
    },
  );

  return response.data;
}
